import { Injectable } from '@angular/core';
import { APIService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class JoinOurCommunityService {

  constructor(private readonly apiService: APIService) { }

  getAllParkingLot(request: any) {
    return this.apiService.postWithAllResponse('ParkingLot/GetAllPakingLot', request)
  }
}
